import { createAsyncThunk } from '@reduxjs/toolkit'

import { getContextMenuCollectionApi } from '../../api'

export const getContextMenuCollectionAction = createAsyncThunk(
  'contextMenuCollection/getContextMenuCollectionAction',
  getContextMenuCollectionApi,
)
